import { api } from './api';

export interface LoginCredentials {
  login: string;
  password: string;
}

export interface AuthUser {
  id: string;
  login: string;
  name: string;
}

export interface LoginResponse {
  user: AuthUser;
}

export const authService = {
  login: (credentials: LoginCredentials) =>
    api.post<LoginResponse>('/api/auth/login', credentials),

  getMe: () => api.get<AuthUser>('/api/auth/me'),

  logout: () => api.post<{ ok: boolean }>('/api/auth/logout', {}),
};
